<template lang="pug">
  .icon-columns__block
    img.icon-columns__icon(v-lazy="iconUrl" :alt="iconAlt")
    h3.icon-columns__block-title {{ title }}
    p.icon-columns__block-info(v-if="info" :class="infoClass") {{ info }}
</template>

<script>
export default {
  name: 'IconColumn',
  props: {
    title: String,
    info: {
      type: String,
      default: null
    },
    textAlignment: {
      type: String,
      validator: function (val) {
        return ['left', 'center', 'right'].includes(val);
      }
    },
    iconUrl: String,
    iconAlt: {
      type: String,
      default: ''
    }
  },
  computed: {
    infoClass () {
      const classes = { 
        left: 'u-text-left',
        center: 'u-text-center',
        right: 'u-text-right'
      }

      return classes[this.textAlignment];
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-columns__block {
  flex: 1;
  margin-top: 9px;
  margin-bottom: 9px;

  @include tablet-up {
    margin-top: 0;
    margin-bottom: 0;
    margin-left: 50px;
    margin-right: 50px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  @include mobile-only {
    max-width: 250px;
  }

  &-title {
    margin-top: 18px;
    margin-bottom: 4px;
  }

  &-info {
    //
  }

  &-title,
  &-info {
    font-size: rem(14);
    line-height: rem(18);
  }
}
</style>